import { render } from "./SolutionDetailTwoFactor.vue?vue&type=template&id=d0cb5e50"
import script from "./SolutionDetailTwoFactor.vue?vue&type=script&lang=js"
export * from "./SolutionDetailTwoFactor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__